
import { Component } from "vue-property-decorator";
import { BaseView } from "@components/base/view";
import PeergroupList from "@components/peergroups/list.vue";
import { useLoader } from "@composables/loader";
import { apiService } from "@services/api.service";
import { AxiosError } from "axios";
import { NavigationGuardNext } from "vue-router";
import { ciTrackingService } from "@services/ci-tracking.service";
import BestFundsMetaImage from "@images/best_funds.jpg";
import { MetaInfo } from "vue-meta";
import { ADS_INVENTORY } from "@models/constants/ads_inventory";
import { alternateService } from "@services/alternate.service";

@Component<any>({
  name: "ci-seo-peergroups",
  components: {
    "ci-peergroup-list": PeergroupList,
  },
  metaInfo(): MetaInfo {
    return {
      title: this.metaOptions.metaTitle,
      link: alternateService.fromRoute(this.$route),
      meta: [
        { vmid: "description", name: "description", content: this.metaOptions.metaDescription },
        { vmid: "og:title", property: "og:title", content: this.metaOptions.metaTitle },
        { vmid: "og:description", property: "og:description", content: this.metaOptions.metaDescription },
        { vmid: "og:image", property: "og:image", content: this.metaOptions.metaImage },
        { vmid: "twitter:title", name: "twitter:title", content: this.metaOptions.metaTitle },
        { vmid: "twitter:description", name: "twitter:description", content: this.metaOptions.metaDescription },
        { vmid: "twitter:image", name: "twitter:image", content: this.metaOptions.metaImage },
      ],
    };
  },
})
export default class extends BaseView {
  public peergroups: Products.PeergroupItem[] = [];

  public get metaOptions(): Record<string, any> {
    const locationPath = window.location.origin;
    const image = BestFundsMetaImage;

    return {
      metaTitle: this.$t("ui.views.products.seo.peergroups.index.meta_tags.title") as string,
      metaDescription: this.$t("ui.views.products.seo.peergroups.index.meta_tags.description") as string,
      metaImage: (locationPath + image) as string,
    };
  }

  public get adIds(): { header: string; skyscraper: string; sidebar_2nd: string } {
    return {
      header: ADS_INVENTORY.peergroup_ranking_header_slot.dom_id,
      skyscraper: ADS_INVENTORY.peergroup_ranking_sidebar_top.dom_id,
      sidebar_2nd: ADS_INVENTORY.peergroup_ranking_sidebar_2nd.dom_id,
    };
  }

  public async handlePeergroupInput(
    peergroup: Nullable<Products.PeergroupTile | Products.PeergroupItem>
  ): Promise<void> {
    if (peergroup === null) {
      return;
    }
    await this.$router.push({ name: this.$routes.PRODUCTS_PEERGROUPS_SHOW, params: { id: peergroup.slug } });
  }

  public async beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): Promise<void> {
    const loader = useLoader();
    loader.start();

    try {
      const peergroups = await apiService.peergroups.all({ active: true });

      next((vm: any) => {
        vm.peergroups = peergroups.data.peergroups.filter((peergroup) => peergroup.name.length > 0);
        ciTrackingService.trackView("TopPeergroupProductsIndexPage");
      });
    } catch (err) {
      apiService.handleRoutingAPIError(err as AxiosError, (routerError) => loader.setError(routerError));
      next();
    } finally {
      loader.stop();
    }
  }
}
